import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useState } from 'react';
import fieldLogic from '../logic/fieldsLogic';
import useInputRef from './useInputRef';
import RichtextEditor from '../components/RichtextEditor';
import Description from '../controls/Description';
import LookupDialog from '../binding/LookupDialog';
var TOOLBARS_MAP = {
  undo: 'undo',
  redo: 'redo',
  bold: 'bold',
  italic: 'italic',
  underline: 'underline',
  strikethrough: 'strikethrough',
  'select-font': 'fontselect',
  'select-size': 'fontsizeselect',
  'select-format': 'formatselect',
  'align-text': ['alignleft', 'aligncenter', 'alignright', 'alignjustify'],
  outdent: 'outdent',
  indent: 'indent',
  'numbered-list': 'numlist',
  'bullet-list': 'bullist',
  foreground: 'forecolor',
  background: 'backcolor',
  superscript: 'superscript',
  subscript: 'subscript',
  clearformat: 'removeformat',
  'insert-image': 'image',
  link: 'link',
  'insert-table': 'table',
  plaintext: 'plaintext'
};
/**
 * @param {string} toolbar
 * @returns {import('../components/RichtextEditor/types').Toolbar}
 */

var parseToolbar = function parseToolbar(toolbar) {
  /** @type {Array<Array<string>>} */
  var toolbarJSON = JSON.parse(toolbar.replace(/'/g, '"'));
  return {
    groups: toolbarJSON.map(function (group) {
      return {
        controls: group.map(function (c) {
          return {
            type: TOOLBARS_MAP[c]
          };
        })
      };
    })
  };
};

var RichtextField = function RichtextField(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var description = props.description,
      error = props.error,
      readonly = props.readonly;
  var value = props.value,
      active = props.active,
      fieldId = props.fieldId,
      dispatch = props.dispatch,
      toolbar = props.toolbar;
  var lookupVisiblity = props.lookupVisiblity,
      xpath = props.xpath;

  var onChange = function onChange(content) {
    return fieldLogic.onChange(fieldId, content, dispatch);
  };

  var onFocus = function onFocus() {
    return fieldLogic.onFocus(fieldId, dispatch);
  };

  var onBlur = function onBlur() {
    return fieldLogic.onBlur(fieldId, dispatch);
  };

  var onLookup = function onLookup() {
    return setOpen(true);
  };

  var onClose = function onClose(e, reason) {
    if (reason && reason == 'backdropClick') return;
    setOpen(false);
  };

  var tinyToolbar = toolbar ? parseToolbar(toolbar) : null;
  var showLookupButton = xpath && lookupVisiblity !== 'hide';
  return React.createElement(React.Fragment, null, React.createElement(RichtextEditor, {
    active: active,
    error: error,
    initialValue: value,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onLookup: showLookupButton && onLookup,
    toolbar: tinyToolbar
  }), React.createElement(Description, {
    error: error,
    description: description
  }), open && React.createElement(LookupDialog, {
    onClose: onClose,
    fieldId: fieldId
  }));
};

export default React.memo(RichtextField);